import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WaitlistForm = ({ size = "default", testidPrefix = "hero" }) => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | done
  const [position, setPosition] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (status === "loading" || status === "done") return;
    const value = email.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      toast.error("Enter a valid email address.");
      return;
    }
    setStatus("loading");
    try {
      const { data } = await axios.post(`${API}/waitlist`, { email: value });
      setPosition(data.position);
      setStatus("done");
      if (data.status === "already_joined") {
        toast("You're already on the list.", { description: "No excuses \u2014 we remember you." });
      } else {
        toast.success("You're in. Confirmation sent.", {
          description: `Spot #${data.position} secured on the ledger.`,
        });
      }
    } catch (err) {
      setStatus("idle");
      toast.error("Something broke. Try again.");
    }
  };

  const big = size === "large";

  if (status === "done") {
    return (
      <div
        data-testid={`${testidPrefix}-waitlist-success`}
        className={`flex items-center gap-3 border border-[#516A38] bg-[#516A38]/10 px-5 ${big ? "py-5" : "py-4"}`}
      >
        <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#516A38]">
          <Check className="h-3.5 w-3.5 text-black" strokeWidth={3} />
        </span>
        <div className="font-mono text-xs uppercase tracking-[0.15em] text-[#A7C08A] leading-relaxed">
          Confirmation sent{position ? ` \u2014 spot #${position}` : ""}. Check your inbox.
        </div>
      </div>
    );
  }

  return (
    <form
      onSubmit={submit}
      data-testid={`${testidPrefix}-waitlist-form`}
      className={`flex flex-col sm:flex-row w-full max-w-xl border border-[#1F1F1F] bg-[#0A0A0A] ${big ? "" : ""}`}
    >
      <input
        type="email"
        required
        aria-label="Email address"
        data-testid={`${testidPrefix}-waitlist-email-input`}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@example.com"
        className={`flex-1 bg-transparent px-5 ${big ? "py-5 text-lg" : "py-4"} font-mono text-white placeholder:text-[#5A5A5A] outline-none focus:bg-white/[0.02] transition-colors`}
      />
      <button
        type="submit"
        aria-label="Join Waitlist"
        data-testid={`${testidPrefix}-waitlist-submit-button`}
        disabled={status === "loading"}
        className={`sweep-btn group flex items-center justify-center gap-2 bg-[#C9A94B] px-6 ${big ? "py-5" : "py-4"} font-mono text-xs font-bold uppercase tracking-[0.2em] text-black transition-colors disabled:opacity-70`}
      >
        {status === "loading" ? "Securing\u2026" : "Join Waitlist"}
        {status !== "loading" && (
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={2.5} />
        )}
      </button>
    </form>
  );
};
